import * as React from "react";
import { UserType } from "../../../entities/User";

type Props = {
  userType?: UserType;
  referenceNumber: number;
};

/**
 * Control for displaying an order reference.
 */
const ReferenceNumber = (props: Props) => (
  <div className="order__reference-number">
    <strong>Reference number:</strong>&nbsp;{props.referenceNumber}
  </div>
);

export default ReferenceNumber;
